"use client";

import { Menu } from "lucide-react";
import { Link } from "@/i18n/navigation";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { marketing_nav_sections, type MarketingNavLink } from "./marketing-nav";

const mobile_nav_link_class_name =
	"block rounded-lg px-3 py-2 leading-none no-underline outline-hidden transition-colors hover:bg-gray-50 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 font-normal";

function MobileNavLink({
	item,
	onClick
}: {
	item: MarketingNavLink;
	onClick: () => void;
}) {
	if (item.external) {
		return (
			<a
				href={item.href}
				target="_blank"
				rel="noopener noreferrer"
				onClick={onClick}
				className={mobile_nav_link_class_name}
			>
				<span className="font-medium text-slate-950">{item.title}</span>
				{item.description && <span className="mt-1 block text-xs leading-relaxed text-slate-500">{item.description}</span>}
			</a>
		);
	}

	return (
		<Link href={item.href} onClick={onClick} className={mobile_nav_link_class_name}>
			<span className="font-medium text-slate-950">{item.title}</span>
			{item.description && <span className="mt-1 block text-xs leading-relaxed text-slate-500">{item.description}</span>}
		</Link>
	);
}

export function MobileNav() {
	const [open, setOpen] = useState(false);
	const close = () => setOpen(false);

	return (
		<Sheet open={open} onOpenChange={setOpen}>
			<SheetTrigger asChild>
				<Button
					variant="ghost"
					className="mr-2 px-0 text-base hover:bg-transparent focus-visible:bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 md:hidden"
				>
					<Menu className="h-8 w-8" />
					<span className="sr-only">Toggle menu</span>
				</Button>
			</SheetTrigger>
			<SheetContent side="left" className="bg-ss-lightest-blue pl-1 pr-0">
				<div className="h-full overflow-y-auto px-7 pb-6 pt-6">
					<div className="flex flex-col space-y-8">
						{marketing_nav_sections.map((section) => (
							<div key={section.title} className="flex flex-col space-y-2">
								<h4 className="text-lg font-medium">{section.title}</h4>
								<div className="flex flex-col space-y-1.5 rounded-xl bg-white p-3">
									{section.items?.length ? (
										section.items.map((item) => (
											<MobileNavLink key={item.href} item={item} onClick={close} />
										))
									) : (
										<MobileNavLink item={section} onClick={close} />
									)}
								</div>
							</div>
						))}
					</div>
				</div>
			</SheetContent>
		</Sheet>
	);
}
